export class FichierUtils {

	/**
	 * Normalise le nom du fichier, en supprimant les caractères spéciaux (&,é, ...).
	 * @param fichier le fichier à renommer.
	 * @private
	 */
	static normaliserNomFichier(fichier: File): File {
		// Dans un premier temps, on remplace les caractères avec accents.
		let nomFichierFinal = fichier.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

		// Puis, on supprime tous les caractères illégaux dans le nom du fichier.
		nomFichierFinal = nomFichierFinal.replace(/[^a-zA-Z0-9 .]/g, '');
		const nomFichierFinalSplit = nomFichierFinal.split('.');
		// Si le nom du fichier n'est pas vide ou composé que d'espaces alors on laisse le nom du fichier après retrait des caractères illégaux
		if (nomFichierFinalSplit.length > 2 || /\S/.test(nomFichierFinalSplit[0])) {
			return new File([fichier], nomFichierFinal, {type: fichier.type});
		}
		// Sinon, on met un '-' comme nom de fichier.
		else {
			nomFichierFinal = '-.' + nomFichierFinalSplit[1];
			return new File([fichier], nomFichierFinal, {type: fichier.type});
		}
	}
}
